/* Progressive enhancement: without JS the whole description remains readable. */
if (!customElements.get('izy-description')) {
  customElements.define('izy-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.izy-description__content');
      this.button = this.querySelector('.izy-description__toggle');
      if (!this.content || !this.button || this.observer) return;
      this.expanded = false;
      this.onToggle = () => { this.expanded = !this.expanded; this.update(); };
      this.onFocus = () => { if (this.hasAttribute('data-clamped')) { this.expanded = true; this.update(); } };
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.button.addEventListener('click', this.onToggle);
      this.content.addEventListener('focusin', this.onFocus);
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.content);
      this.observer.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    update() {
      const limit = parseFloat(getComputedStyle(this).getPropertyValue('--izy-description-preview-height')) || 100;
      const needed = this.content.scrollHeight > limit + 2;
      this.button.hidden = !needed;
      this.toggleAttribute('data-clamped', needed && !this.expanded);
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.querySelector('[data-izy-more]').hidden = this.expanded;
      this.button.querySelector('[data-izy-less]').hidden = !this.expanded;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.observer = null;
      this.button?.removeEventListener('click', this.onToggle);
      this.content?.removeEventListener('focusin', this.onFocus);
    }
  });
}
